const elasticlunr = require('elasticlunr')

module.exports = {
  namespaced: true,

  state: {
    /**
     * Whether to show the search tray
     * @type {Boolean}
     */
    show: false,

    /**
     * The current search index
     * @type {Object, Boolean}
     */
    index: false,

    /**
     * The current search string
     * @type {String}
     */
    search: '',

    /**
     * The current search results
     * @type {Array}
     */
    results: []
  },

  actions: {
    /**
     * Show the search tray
     */
    show ({ commit }) {
      commit('SET_SHOW', true)
    },

    /**
     * Hide the search tray
     */
    hide ({ commit }) {
      commit('SET_SHOW', false)
    },

    /**
     * Create the index to search on
     */
    setData ({ commit }, data) {
      commit('SET_INDEX', elasticlunr.Index.load(data))
    },

    /**
     * Perform a search
     */
    search ({ commit, state }, settings) {
      const term = cleanTerm(settings.term)
      const results = state.index.search(term, settings.opts)

      commit('SET_RESULTS', [])
      commit('SET_RESULTS', results)
      commit('SET_SEARCH', term)
    },

    /**
     * Set the results
     */
    setResults ({ commit }, results) {
      commit('SET_RESULTS', results)
    },

    /**
     * Reset the search store
     */
    reset ({ commit }) {
      commit('SET_INDEX', {})
      commit('SET_SEARCH', '')
      commit('SET_RESULTS', [])
    }
  },

  mutations: {
    SET_SHOW (state, value) {
      state.show = value
    },

    SET_INDEX (state, data) {
      state.index = data
    },

    SET_SEARCH (state, value) {
      state.search = value
    },

    SET_RESULTS (state, results) {
      state.results = results
    }
  }
}

/**
 * Perform various cleaning tasks on term before submitting to search
 * @param  {String} term
 * @return {String}
 */
function cleanTerm (term) {
  term = term.replace(/'s/, '’s')

  return term
}



// WEBPACK FOOTER //
// ./src/store/search.js